import { Component, HostListener, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';

import { EventService } from '../../../services/events/event.service';

declare var $: any;
declare var FullCalendar: any;
declare var moment: any;
declare var window: any;

@Component({
  selector: 'app-full-calendar',
  templateUrl: './full-calendar.component.html',
  styleUrls: ['./full-calendar.component.scss'],
})
export class FullCalendarComponent implements OnInit, OnChanges, OnDestroy {
  /**
   * Default view for calendar
   */
  @Input() defaultView: string;

  /**
   * Events search options
   */
  @Input() filterOptions: any = {
    attorneys:   [],
    event_types: [],
    locations:   [],
    staff:       []
  };

  @Input() timeZone: string;

  /**
   * Events fetched for calendar
   * @param {EventEmitter<Array<any>> = new EventEmitter(} ) events variable name
   */
  @Output() events: EventEmitter<Array<any>> = new EventEmitter();

  /**
   * Emits event id to show a dialog with event info
   * @param {EventEmitter<number>     = new EventEmitter(} ) showEvent [description]
   */
  @Output() showEvent: EventEmitter<number> = new EventEmitter();

  /**
   * Full calendar HTML Element
   * @param {[type]} 'fullCalendar' HTML Element
   */
  @ViewChild('fullCalendar', { static: true }) fullCalendarElement: ElementRef;

  public calendar: any;
  componentDestroyed: boolean = false;

  private fullCalendarViews: any = { agendaDay: 'timeGridDay', day: 'timeGridDay', agendaWeek: 'timeGridWeek', month: 'dayGridMonth', 'multi-day': 'dayGridMonth', week: 'timeGridWeek' };

  /**
   * Constructor
   * @param {EventService} private eventService Service to access events backend
   */
  constructor(private eventService: EventService) {}

  // Component lifecycle events

  /**
   * Called on events initialization
   */
  ngOnInit() {
    this.initializeCalendar();
  }

  ngOnDestroy() {
    this.componentDestroyed = true;
    this.destroyCalendar();
  }

  /**
   * Called when component variables changes
   * @param {SimpleChanges} changes Component variable changes as Angular Simple Changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.defaultView && changes.defaultView.currentValue) {
      if (this.calendar && this.calendar.changeView) {
        console.log('View changes', this.defaultView);
        console.log(this.fullCalendarViews[this.defaultView] || 'dayGridMonth');
        this.calendar.changeView(this.fullCalendarViews[this.defaultView] || 'dayGridMonth');
      }
      //this.destroyCalendar();
      //this.initializeCalendar();
    } else if (changes.filterOptions && changes.filterOptions.currentValue) this.refreshView();
  }

  /**
   * Triggers on window resize event
   * @param {resize'} 'window  window object
   * @param {[type]}  '$event' resize event
   */
  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.refreshView();
  }

  // Component methods

  /**
   * Destroy full calendar
   */
  destroyCalendar() {
    if (this.calendar) {
      this.calendar.destroy();
      this.calendar = null;
    }
  }

  /**
   * Initialize full calendar
   */
  initializeCalendar() {
    console.log('Initializaing fullcalendar');
    let initialView: string = '';
    let scope: FullCalendarComponent = this;
    let calendar: any = new FullCalendar.Calendar(this.fullCalendarElement.nativeElement, {
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: '',
      },
      initialView: this.fullCalendarViews[this.defaultView] || 'dayGridMonth',
      events: (fetchInfo: any, successCallback: any, failureCallback: any) => {
        scope.updateEvents(fetchInfo.start, fetchInfo.end, fetchInfo.timeZone, successCallback, scope.defaultView == 'multi-day');
      },
      eventClick: function (info: any) {
        scope.showEvent.emit(Number(String(info.event.id).split('_')[0]));
      },
      //eventContent: function (arg) {
      //
      //},
      eventContent: (arg: any, createElement: any) => {
        let result: any = scope.renderFullCalendarEvent(arg.event, createElement);
        return createElement('span', {}, result);
      },
      slotEventOverlap: true,
      nextDayThreshold: '00:00:00',
      themeSystem: 'bootstrap4',
      dayMaxEventRows: true,
      eventDisplay: 'block',
      timeZone: 'America/New_York' || this.timeZone || 'Eastern Time (US & Canada)',
    });
    calendar.render();
    this.calendar = calendar;
    window.fcal = calendar;
  }

  /**
   * Render full calendar event
   * @param {any} event   Event object from backend
   * @param {any} element HTML element
   */
  renderFullCalendarEvent(event: any, createElement: any) {
    let result: Array<any> = [];
    let extendedProps: any = event.extendedProps;
    if (event.color != '#777777' || event.color != '#777' || event.color != '777' || event.color != '777777' || event.backgroundColor != '#777777' || event.backgroundColor != '#777' || event.backgroundColor != '777' || event.backgroundColor != '777777') {
      result.push(createElement('b', {}, extendedProps.event_type_name + ' '));
      result.push(createElement('span', {}, extendedProps.display_name));
    } else {
      result.push(createElement('span', {}, extendedProps.display_name));
    }
    //let fc_title: any = element.find('.fc-title');
    //if(fc_title.length < 1)
    //	element.find('.fc-content').append('<div class="fc-title"></div>');
    //fc_title = element.find('.fc-title');
    //fc_title.html(title);
    console.log('render');
    let event_start: any = this.eventDisplayMoment(extendedProps.display_start, event.start);
    let event_end: any = null;
    if (event.end || extendedProps.display_end) event_end = this.eventDisplayMoment(extendedProps.display_end, event.end);
    if (this.eventService.checkIfAllDay(event_start, event_end)) {
      //element.find('.fc-time').html("<b>All day</b>");
      result.push(createElement('b', {}, 'All day'));
      return result;
    }
    let sa: string = event_start.format('a').substring(0, 1);
    let sm: string = event_start.format(':mm');
    if (sm == ':00') sm = '';
    sa = event_start.format('h') + sm + sa;
    if (event_end) {
      let ea: string = event_end.format('a').substring(0, 1);
      let em: string = event_end.format(':mm');
      if (em == ':00') em = '';
      ea = event_end.format('h') + em + ea;
      if (sa != ea) sa += '-' + ea;
    }
    //element.find('.fc-time').html("<b>"+sa+"</b>");
    //if(event.title)
    //	element.prop('title', event.title);
    //else
    //	element.prop('title', 'phone');
    result.unshift(createElement('b', {}, sa + ' '));
    console.log(result);
    return result;
  }

  /**
   * FullCalendar v5 uses UTC-coercion for named time zones unless a timezone
   * plugin is installed. Keep the wall-clock time as a no-offset string so the
   * grid position uses the same local time we show in the label.
   */
  fullCalendarWallTime(dateTime: any): string {
    return moment(dateTime).format('YYYY-MM-DDTHH:mm:ss');
  }

  /**
   * Use the precomputed wall-clock time when rendering labels. Falling back to
   * the event date preserves rendering for any event not produced here.
   */
  eventDisplayMoment(displayDateTime: string, fallbackDateTime: any): any {
    if (displayDateTime) return moment(displayDateTime, 'YYYY-MM-DDTHH:mm:ss');
    return moment(fallbackDateTime);
  }

  /**
   * FullCalendar's named-time-zone UTC coercion represents calendar wall dates
   * as UTC date markers. Reading those markers in the browser's local zone can
   * move the requested range to the previous day.
   */
  fullCalendarRangeDate(date: any): string {
    return moment.utc(date).format('YYYY-MM-DD');
  }

  /**
   * Refresh View
   */
  refreshView() {
    if (this.componentDestroyed) return;
    if (this.calendar) this.calendar.refetchEvents(); //$(this.fullCalendarElement.nativeElement).fullCalendar('refetchEvents');
  }

  /**
   * Process events received from backend to match full calendar format
   * @param {any} data Backend response with events
   */
  processEvents(data: any, multiday: boolean = false) {
    let split_events: any = [];
    for (let i in data) {
      let currentEvent: any = data[i];
      if (!currentEvent) continue;
      currentEvent.id = currentEvent.id.toString();
      console.log('Process');
      currentEvent.end = this.eventService.addOffset(moment(currentEvent.end), currentEvent.e_offset);
      currentEvent.start = this.eventService.addOffset(moment(currentEvent.start), currentEvent.s_offset);
      currentEvent.display_start = this.fullCalendarWallTime(currentEvent.start);
      currentEvent.display_end = this.fullCalendarWallTime(currentEvent.end);
      if (currentEvent.event_type_name == 'placekeeper') {
        let attorneySelectedCount: number = 0;
        if (this.filterOptions && this.filterOptions.attorneys) for (let attorney of this.filterOptions.attorneys) if (attorney.selected) attorneySelectedCount += 1;
        if (attorneySelectedCount <= 1) {
          currentEvent.color = '#000000';
          currentEvent.textColor = '#ffffff';
        } else currentEvent.textColor = '#000000';
      } else currentEvent.textColor = '#ffffff';
      currentEvent.backgroundColor = currentEvent.color;
      if (currentEvent.backgroundColor && currentEvent.backgroundColor[0] != '#') currentEvent.backgroundColor = '#' + currentEvent.backgroundColor;
      if (currentEvent.textColor && currentEvent.textColor[0] != '#') currentEvent.textColor = '#' + currentEvent.textColor;
      if (moment(currentEvent.end).date() != moment(currentEvent.start).date() || moment(currentEvent.end).diff(moment(currentEvent.start), 'seconds') > 86400) {
        let current_date: any = moment(currentEvent.start).add(1, 'day');
        current_date = this.eventService.addOffset(moment(current_date), currentEvent.s_offset);
        current_date.hour(0);
        current_date.minute(0);
        let end: any = moment(currentEvent.end);
        while (current_date < end) {
          let splitEvent: any = {};
          for (let key in currentEvent) if (currentEvent.hasOwnProperty(key)) splitEvent[key] = currentEvent[key];
          splitEvent.id = currentEvent.id + '_' + current_date.date();
          splitEvent.event_id = currentEvent.id;
          splitEvent.color = currentEvent.color;
          splitEvent.event_type_name = 'Contd ... ' + currentEvent.event_type_name;
          splitEvent.display_name = currentEvent.display_name;
          splitEvent.textColor = currentEvent.textColor;
          splitEvent.title = currentEvent.title;
          console.log('Split');
          splitEvent.start = this.eventService.addOffset(moment(current_date), currentEvent.s_offset);
          splitEvent.end = current_date.date() == end.date() ? end : this.eventService.addOffset(moment(current_date).hour(23).minute(59), currentEvent.s_offset);
          splitEvent.display_start = this.fullCalendarWallTime(splitEvent.start);
          splitEvent.display_end = this.fullCalendarWallTime(splitEvent.end);
          if (!multiday) {
            splitEvent.start = splitEvent.display_start;
            splitEvent.end = splitEvent.display_end;
          }
          splitEvent.s_offset = currentEvent.s_offset;
          splitEvent.e_offset = currentEvent.e_offset;
          splitEvent.matter_id = currentEvent.matter_id;
          splitEvent.matter_name = currentEvent.matter_name;
          splitEvent.date_position = current_date.format('dddd MMM DD YYYY');
          splitEvent.backgroundColor = currentEvent.backgroundColor;
          split_events[split_events.length] = splitEvent;
          current_date.add(1, 'day');
        }
        currentEvent.end = this.eventService.addOffset(moment(currentEvent.start), currentEvent.s_offset).hour(23).minute(59);
        currentEvent.display_end = this.fullCalendarWallTime(currentEvent.end);
        currentEvent.date_position = moment(currentEvent.start).format('dddd MMM DD YYYY');
      } else currentEvent.date_position = moment(currentEvent.start).format('dddd MMM DD YYYY');
      if (!multiday) {
        console.log(currentEvent.start, currentEvent.end);
        currentEvent.start = currentEvent.display_start;
        currentEvent.end = currentEvent.display_end;
        console.log(currentEvent.start, currentEvent.end);
      }
    }
    data = data.concat(split_events);
    console.log('Events', data);
    let len: number = data.length;
    for (let j = 0; j < len; j++)
      for (var k = j + 1; k < len; k++)
        if (data[j].start > data[k].start) {
          var tmp = data[j];
          data[j] = data[k];
          data[k] = tmp;
        }
    console.log(data);
    if (multiday) this.events.emit(data);
    return data;
  }

  /**
   * Function to update events, compatible as fullcalendar callback function for updating events
   * @param {any} start    Start date from fullcalendar
   * @param {any} end      End date from fullcalendar
   * @param {any} timezone Time zone
   * @param {any} callback Callback function to be called once events are fetched
   * @param {any} multiday Indicates if view is multiday view
   */
  updateEvents(start: any, end: any, timezone: any, callback: any, multiday: any, agnostic: boolean = false) {
    if (this.componentDestroyed) return;
    let attorney_ids: Array<number> = [];
    let staff_ids: Array<number> = [];
    let location_ids: Array<number> = [];
    let event_type_ids: Array<number> = [];
    for (let attorney of this.filterOptions.attorneys) if (attorney.selected) attorney_ids.push(attorney.id);
    for (let staff_member of this.filterOptions.staff) if (staff_member.selected) staff_ids.push(staff_member.id);
    for (let location of this.filterOptions.locations) if (location.selected) location_ids.push(location.id);
    for (let event_type of this.filterOptions.event_types) if (event_type.selected) event_type_ids.push(event_type.id);
    console.log(start, end, this.filterOptions.timezone_offset, this.filterOptions);
    this.eventService.formOptions().then(() => {
      if (this.componentDestroyed) return;
      this.eventService
        .index({
          start: this.fullCalendarRangeDate(start) + 'T00:00:00' + moment(start).utcOffset(this.filterOptions.timezone_offset).format('Z'),
          end: this.fullCalendarRangeDate(end) + 'T00:00:00' + moment(end).utcOffset(this.filterOptions.timezone_offset).format('Z'),
          event_types: event_type_ids,
          event_attorneys: attorney_ids,
          event_staff: staff_ids,
          event_locations: location_ids,
          event_matter_number: this.filterOptions.matter_id,
          inactive: this.filterOptions.inactive,
          recurring: this.filterOptions.recurring,
          company: this.filterOptions.company,
          shadow: this.filterOptions.shadow,
          placekeeper: this.filterOptions.placekeeper,
          multiday: multiday,
          agnostic: agnostic,
        })
        .then((response_json) => {
          if (this.componentDestroyed) return;
          callback(this.processEvents(response_json, multiday));
        });
    });
  }
}
